import styled, { keyframes } from 'styled-components';

import { colors } from 'chime-ui/system';

// Create the keyframes
export const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const spinnerStyles = () => `
  position: absolute;
  left: 0;
  right: 0;
  bottom: 50%;
  width: 36px;
  height: 36px;
  margin: 0 auto;
  border-radius: 50px;
  border: 4px solid rgba(102, 102, 102, 0.5);
  border-left-color: ${colors['bg-action-primary-hover']};
  border-top-color: ${colors['bg-action-primary-hover']};
  background: white;
`;

export const Spinner = styled.div`
  ${props => spinnerStyles(props)}
  /** "transform" attribute doesn't work during webview redirect */
  animation: ${rotate360} 2s linear infinite;
`;

/**
 * During a brief redirect moment in the react-native webview, certain style
 * attributes don't work, so we must render a fallback spinner (which doesn't actually spin)
 */
export const SpinnerFallback = styled.div`
  ${props => spinnerStyles(props)}
`;
